class MFRBlogAccordionCarousel {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element );
        
        this.selectors = {
            accordion: "[data-accordion]",
            carousel: ".carousel__slides",
            accordionContent: ".accordion-content"
        }

        this.settings = {
            wrapAround: false,
            prevNextButtons: true,
            adaptiveHeight: true,
            pageDots: true,
            selectedAttraction: 0.1,
            friction: 0.55,
            cellAlign: "center",
            groupCells: true,
            contain: true,
            on: {
              success( e ) {
                console.log( e );
              }
            }
        }

        this.init();
    }

    init() {
        this.$accordion = this.$element.find( this.selectors.accordion );
        this.$carousel = this.$element.find( this.selectors.carousel );
        this.$accordionContent = this.$element.find( this.selectors.accordionContent );

        this.disableAccordion();
        this.showHideContent();
        this.initializeCarousel();
        this.showHideContent( true );
        this.initializeAccordion();
        this.setPagination();
    }

    disableAccordion() {
        this.$accordion.foundation( "_destroy" );
    }

    showHideContent( hide = false ) {
        if( hide ) {
            this.$accordionContent.css( "display", "" );
        }
        else {
            this.$accordionContent.show();
        }
    }

    setPagination() {
        Array.from(this.$element.find('.flickity-page-dots')).forEach(item => {
            if ( item.children.length > 1 ) {
                item.classList.remove('hidden')
            } else {
                item.classList.add('hidden')
            }
        })
    }

    initializeCarousel() {
        this.$carousel.flickity( this.settings )
    }

    initializeAccordion() {
        const accordionInstance = new Foundation.Accordion( this.$accordion );
    }
}